import React, { useContext } from 'react'

import { DataContext } from './DataContext'
import NoDataComponent from '../../../elem/table/client/NoDataComponent'
import TableContent from '../../../elem/table/client/TableContent'
import parseColumns from '../../../../utils/table/parseColumns'
import withConfig from '../../../wrappers/withConfig'

export default withConfig(({ config }) => {
    const { detailData, filterData, visibleTab, isLoading } = useContext(DataContext)
    const { ID_COLUMN, EXPLORER_LINK_COLUMN } = config
    if (
            detailData &&
            detailData.project &&
            filterData &&
            filterData.project &&
            visibleTab === 'project'
    ) {
        const formFields = filterData.project
        const projectDetailsData = detailData.project
        const columns = parseColumns(projectDetailsData, formFields, EXPLORER_LINK_COLUMN, ID_COLUMN)
        return (
            <div className="is-size-7">
                <NoDataComponent data={projectDetailsData} isLoading={isLoading}/>
                <TableContent
                    name="projectDetails"
                    columns={columns}
                    data={projectDetailsData}
                    containerClass={'detailTableWrapper'}
                    loading={isLoading}
                    initialSort={'ProjectName'}
                    initialSortDesc={true}
                />
            </div>
        )

    } else {
        return null
    }
})